import PageHeaderFull from "components/PageHeaderFull"
import VideoHero from "./VideoHero"

export default function PageHeaderFullDynamic({ blok }) {
  return blok.video && blok.video.length ? <VideoHero {...blok} /> : <PageHeaderFull {...blok} />
}
